
/** `value` bounded to `[low, high]`. NaN yields `low`; an infinity yields the
 *  bound it is past. Inverted bounds yield `low`, which is what
 *  `render/window.ts` relies on to produce an empty window rather than a
 *  mirrored one. */
export function clamp(value: number, low: number, high: number): number {
  if (Number.isNaN(value)) return low;
  return value < low ? low : value > high ? high : value;
}

/** A fraction. `clamp(value, 0, 1)`, named. */
export function clamp01(value: number): number {
  return clamp(value, 0, 1);
}
